import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { RegisterComponent } from './register.component';
import { AuthGuard }      from '../shared/auth.guard';


@NgModule({
  imports: [
    RouterModule.forChild([
      { path: 'register', component: RegisterComponent,  canActivate: [AuthGuard] }
    ])
  ],
  exports: [RouterModule]
})
export class RegisterRoutingModule { 

  
}
